import { Text, List, ListItem, Button, Card, Box, Divider } from '@chakra-ui/react';

import { ArrowForwardIcon } from '@chakra-ui/icons';
import Colors from '../../config/colors';
import { Link } from 'react-router-dom';
import truncate from '../../utils/truncate';
import { IOrder } from '../../interfaces';
import { ORDER_STATUSES } from '../../config/orders';
import OrderStatus from '../pages/catalog/OrderStatus';
import JumpButton from '../jumpButton/JumpButton';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { CATEGORY_IMAGES_PATH } from '../../config/images';
import { PAYMENT_LIST } from '../../config/payments';

interface Props {
    order: IOrder;
}

export default function OrderItem({ order }: Props) {
    const [t] = useTranslation();
    const orderStatuses = Object.values(ORDER_STATUSES);
    const orderStatus = orderStatuses.find((status) => status.id === order.orderStatus.id);

    const isReplenishment = order.type === 'replenishment';

    const paymentSystem = PAYMENT_LIST.find(
        (item) => item.name === order.transaction?.paymentSystem,
    );

    const imgURL = isReplenishment ? paymentSystem?.imgURL : order.mainImage;

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow="hidden"
            variant="unstyled"
            padding="15px"
            boxShadow="rgba(68, 98, 136, 0.25) 0px 3px 12px"
            borderRadius="0px"
            fontWeight="500"
            fontSize="14px"
            backgroundImage={process.env.PUBLIC_URL + '/images/categories/background_spotlight.jpg'}
            backgroundSize="cover"
            display="flex"
            flexDirection="column"
            gap={4}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <OrderStatus orderStatus={orderStatus} />
                <Text color={Colors.lightBlue}>
                    {new Date(order?.createdAt ?? '').toLocaleDateString()}
                </Text>
            </Box>

            <Box display="flex" alignItems="center" gap="2">
                <Box display="flex" width="444px">
                    <List spacing={3} width="100%">
                        <ListItem>
                            {order?.type === 'purchase' && order.product ? (
                                <>
                                    <Text color={Colors.lightBlue} fontSize="12px">
                                        {t('product-name')}
                                    </Text>
                                    <Text color="#fff">{truncate(order.product.name)}</Text>
                                </>
                            ) : (
                                <>
                                    <Text color={Colors.lightBlue} fontSize="12px">
                                        {t('payment-system')}
                                    </Text>
                                    <Text color="#fff">{paymentSystem?.title ?? '–'}</Text>
                                </>
                            )}
                        </ListItem>
                        <ListItem>
                            <Text color={Colors.lightBlue} fontSize="12px">
                                {isReplenishment ? t('amount') : t('price')}
                            </Text>
                            <Text color="#fff">
                                {order.totalPrice} {order.localeType.currency}
                            </Text>
                        </ListItem>
                    </List>
                </Box>
                <LazyLoadImage
                    effect="blur"
                    src={imgURL}
                    style={{ maxWidth: '100%', borderRadius: '10px', maxHeight: '210px' }}
                />
            </Box>

            <Link to={'/user/order/' + order.id} state={{ previousPage: '/orders' }}>
                <JumpButton name={t('order-details')} />
            </Link>
        </Card>
    );
}
